import clsx from "clsx";
import { createElement } from "react";

import {
  textAlignVariants,
  textColourVariants,
  textOverflowVariants,
  textVariants,
  textWhiteSpaceVariants,
  underlineStyles
} from "./Typography.css";
import {
  type PropsWithHTMLAttributes,
  type TextProps,
  type ValidElements
} from "./Typography.types";

export const Typography = <E extends ValidElements = "p">({
  as,
  variant = "body-md",
  colour = "primary-dark",
  textAlign = "left",
  underline = false,
  whiteSpace = "normal",
  overflow,
  children,
  ...props
}: PropsWithHTMLAttributes<E, TextProps<E>>) => {
  const Element = (as || "p") as E;

  // Destructure className to avoid passing it to the element
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { className, ...rest } = props;

  const combinedClassName = clsx(
    textVariants[variant],
    textAlign && textAlignVariants[textAlign],
    overflow && textOverflowVariants[overflow],
    colour && textColourVariants[colour],
    whiteSpace && textWhiteSpaceVariants[whiteSpace],
    underline && underlineStyles
  );

  return createElement(
    Element,
    {
      className: combinedClassName,
      ...rest
    },
    children
  );
};
